<mat-toolbar [ngClass]="{ 'pinned': pinned, 'unpinned': !pinned }">
  @if(showMenuButton) {
    <button mat-icon-button (click)="toggleSideNav.emit()" class="menu-icon">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <span> </span>
  <span class="spacer"></span>
  <div class="header-right">
    <a mat-button>{{ user?.name }}</a>
    @if (isGenesisMode && (currentTenantInfo$ | async); as currentTenant) {
      @if ((hasMultipleActiveTenants$ | async)) {
        <button
          mat-button
          class="tenant-switcher"
          [matMenuTriggerFor]="tenantMenu"
          aria-label="Switch organisation"
        >
          <span class="tenant-switcher__name">{{ currentTenant.organizationName }}</span>
          <mat-icon class="tenant-switcher__chevron">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #tenantMenu="matMenu" xPosition="before">
          @for (tenant of (activeTenants$ | async) ?? []; track tenant.tenantKey) {
            <button
              mat-menu-item
              [disabled]="tenant.tenantKey === currentTenant.tenantKey"
              (click)="switchTenant(tenant.tenantKey, currentTenant.tenantKey)"
            >
              @if (tenant.tenantKey === currentTenant.tenantKey) {
                <mat-icon matPrefix color="primary">check</mat-icon>
              }
              <span>{{ tenant.organizationName }}</span>
            </button>
          }
        </mat-menu>
      } @else {
        <span class="tenant-key">{{ currentTenant.organizationName }}</span>
      }
    }
    <button [matMenuTriggerFor]="afterMenu" color="primary" mat-icon-button>
      <mat-icon aria-hidden="false">account_circle</mat-icon>
    </button>
    <mat-menu #afterMenu="matMenu" xPosition="after">
      <button mat-menu-item>
        <mat-icon matPrefix color="primary">account_circle</mat-icon>
        <span>Profile</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon matPrefix color="warn">exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
